/**
 * 환경변수 단일 진입점. import.meta.env 직접 접근은 이 파일에서만 한다.
 * 원본 REACT_APP_* → VITE_* 1:1 매핑 (Plan §10.3)
 */

const env = import.meta.env

export const config = {
  env: env.VITE_ENV,
  isProduction: env.VITE_ENV === 'production',

  api: {
    /** axios baseURL */
    smartOrder: env.VITE_SMARTORDER_API_URL,
    /** 메뉴 이미지 CDN 베이스 */
    upcloud: env.VITE_UPCLOUD_API_URL,
  },

  kakaoMapKey: env.VITE_KAKAO_MAP_KEY,
  lineLiffId: env.VITE_LINE_LIFF_ID,

  /** PG(payment provider)별 엔드포인트 */
  pg: {
    coam: env.VITE_COAM_URL,
    ksnet: env.VITE_KSNET_URL,
    kpn: env.VITE_KPN_URL,
    kovan: env.VITE_KOVAN_URL,
    softbank: env.VITE_SOFTBANK_URL,
    hecto: env.VITE_HECTO_URL,
    smartro: {
      isProduction: env.VITE_SMARTRO_PRODUCTION === 'true',
      pc: env.VITE_SMARTRO_PC_URL,
      mobile: env.VITE_SMARTRO_MOBILE_URL,
    },
    callgate: {
      api: env.VITE_CALLGATE_URL,
      script: env.VITE_CALLGATE_SCRIPT_URL,
    },
    payStory: {
      api: env.VITE_PAYSTORY_URL,
      script: env.VITE_PAYSTORY_SCRIPT_URL,
    },
  },
} as const
